import { StandalonePostActionDialog } from 'base/components/PostActionDialog';
import { AllasStandaloneNewsletterSignup } from '@/allas/components/NewsletterSignup';
import AllasPlusLogo from '@/allas/public/image/allas-plus-logo-rounded.svg';
import { Icon } from '@/components/Icon';
import { Link } from '@/components/Link';
import { useState } from 'react';

export const AllasStandalonePostActionDialog: typeof StandalonePostActionDialog = (props) => {
  const [isNewsletterSubmitted, setIsNewsletterSubmitted] = useState(false);

  return (
    <StandalonePostActionDialog
      dialog={{
        headline: 'Tack för ditt köp',
        dialogIcon: <AllasPlusLogo className="h-16 w-16 flex-shrink-0" />,
        options: { $closeIcon: { className: 'fill-black' } },
      }}
      content={({ close }) =>
        isNewsletterSubmitted ? (
          <div className="flex flex-col items-center text-center text-headline-sm">
            <Icon name="sent" options={{ size: 'large' }} />
            <h2 className="mt-4">Vad kul!</h2>
            <p className="mt-2 text-body-md">Du är nu anmäld till vårt nyhetsbrev.</p>
            <button
              type="button"
              onClick={close}
              className="mt-6 text-body-sm text-gray-600 underline"
            >
              Stäng
            </button>
          </div>
        ) : (
          <div className="text-headline-sm">
            <p>Välkommen till Allas Plus</p>
            <hr className="my-6 border-t border-gray-200" />
            <AllasStandaloneNewsletterSignup
              headline="Vill du också ha våra nyhetsbrev?"
              submitButton={{ content: 'Anmäl mig' }}
              onSuccess={() => setIsNewsletterSubmitted(true)}
              options={{
                className: 'bg-transparent p-0',
                $headline: {
                  className: 'text-body-md font-primary font-semibold text-black text-center',
                },
              }}
            />
            <div className="mt-6 text-body-md [&>a]:underline">
              Har du frågor eller behöver hjälp med din prenumeration, kontakta oss på{' '}
              <Link href="mailto:kundservice@aller.se" content="kundservice@aller.se" />.
            </div>
            <div className="mt-6 text-center">
              <button
                type="button"
                onClick={close}
                className="text-body-sm text-gray-600 underline"
              >
                Nej tack
              </button>
            </div>
          </div>
        )
      }
    />
  );
};
